export default __webpack_public_path__ + "static/media/pantry1-afterD-1920w.d8119294.png";